// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect_avatar[data-v-ae6509ca] .multiselect .multiselect__option--highlight .avatar {\n  --bg-opacity: 1;\n  background-color: #1EB5F0;\n  background-color: rgba(30, 181, 240, var(--bg-opacity));\n  --text-opacity: 1;\n  color: #1A7BEE;\n  color: rgba(26, 123, 238, var(--text-opacity));\n}", ""]);
// Exports
module.exports = exports;
